/* eslint-disable */
import _m0 from "protobufjs/minimal";
import Long from "long";
import { Timestamp } from "cosmjs-types/google/protobuf/timestamp";
import { Duration } from "cosmjs-types/google/protobuf/duration";
import { BondingCurve, IncentivePlanParams, Params } from "./iro";

export const protobufPackage = "dymensionxyz.dymension.iro";

/** MsgUpdateParams allows to update module params. */
export interface MsgUpdateParams {
  /** Authority is the address that controls the module. */
  authority: string;
  /** NewParams should be fully populated. */
  newParams: Params | undefined;
}

export interface MsgUpdateParamsResponse {
}

/** MsgCreatePlan defines a message to create a new plan. */
export interface MsgCreatePlan {
  /** The address of the plan owner. */
  owner: string;
  /** The ID of the rollapp. */
  rollappId: string;
  /**
   * The amount of tokens allocated for the plan.
   * NOTE: This amount is expected to be defined on the rollapp genesis info
   */
  allocatedAmount: string;
  bondingCurve:
    | BondingCurve
    | undefined;
  /** The start time of the plan. */
  startTime:
    | Date
    | undefined;
  /** The duration of the plan. */
  iroPlanDuration:
    | Duration
    | undefined;
  /** The incentive plan parameters for the tokens left after the plan is settled. */
  incentivePlanParams: IncentivePlanParams | undefined;
}

export interface MsgCreatePlanResponse {
  /** The ID of the plan. */
  planId: string;
}

/** MsgBuy defines a message to buy allocation. */
export interface MsgBuy {
  buyer: string;
  /** The ID of the plan. */
  planId: string;
  /** The amount of tokens to buy. */
  amount: string;
  /** The maximum cost this buy action can incur. */
  maxCostAmount: string;
}

export interface MsgBuyExactSpend {
  buyer: string;
  /** The ID of the plan. */
  planId: string;
  /** The amount of DYM to spend. */
  spend: string;
  /** The minimum tokens this buy action can provide. */
  minOutTokensAmount: string;
}

export interface MsgBuyResponse {
}

/** MsgSell defines a message to sell allocation. */
export interface MsgSell {
  seller: string;
  /** The ID of the plan. */
  planId: string;
  /** The amount of tokens to sell. */
  amount: string;
  /** The minimum income this sell action can incur. */
  minIncomeAmount: string;
}

export interface MsgSellResponse {
}

/** MsgClaim defines a message to claim tokens after the plan is settled. */
export interface MsgClaim {
  claimer: string;
  /** The ID of the plan. */
  planId: string;
}

export interface MsgClaimResponse {
}

function createBaseMsgUpdateParams(): MsgUpdateParams {
  return { authority: "", newParams: undefined };
}

export const MsgUpdateParams = {
  encode(message: MsgUpdateParams, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.authority !== "") {
      writer.uint32(10).string(message.authority);
    }
    if (message.newParams !== undefined) {
      Params.encode(message.newParams, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgUpdateParams {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.authority = reader.string();
          break;
        case 2:
          message.newParams = Params.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgUpdateParams {
    return {
      authority: isSet(object.authority) ? String(object.authority) : "",
      newParams: isSet(object.newParams) ? Params.fromJSON(object.newParams) : undefined,
    };
  },

  toJSON(message: MsgUpdateParams): unknown {
    const obj: any = {};
    message.authority !== undefined && (obj.authority = message.authority);
    message.newParams !== undefined
      && (obj.newParams = message.newParams ? Params.toJSON(message.newParams) : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgUpdateParams>, I>>(object: I): MsgUpdateParams {
    const message = createBaseMsgUpdateParams();
    message.authority = object.authority ?? "";
    message.newParams = (object.newParams !== undefined && object.newParams !== null)
      ? Params.fromPartial(object.newParams)
      : undefined;
    return message;
  },
};

function createBaseMsgUpdateParamsResponse(): MsgUpdateParamsResponse {
  return {};
}

export const MsgUpdateParamsResponse = {
  encode(_: MsgUpdateParamsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgUpdateParamsResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateParamsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): MsgUpdateParamsResponse {
    return {};
  },

  toJSON(_: MsgUpdateParamsResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgUpdateParamsResponse>, I>>(_: I): MsgUpdateParamsResponse {
    const message = createBaseMsgUpdateParamsResponse();
    return message;
  },
};

function createBaseMsgCreatePlan(): MsgCreatePlan {
  return {
    owner: "",
    rollappId: "",
    allocatedAmount: "",
    bondingCurve: undefined,
    startTime: undefined,
    iroPlanDuration: undefined,
    incentivePlanParams: undefined,
  };
}

export const MsgCreatePlan = {
  encode(message: MsgCreatePlan, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.owner !== "") {
      writer.uint32(10).string(message.owner);
    }
    if (message.rollappId !== "") {
      writer.uint32(18).string(message.rollappId);
    }
    if (message.allocatedAmount !== "") {
      writer.uint32(26).string(message.allocatedAmount);
    }
    if (message.bondingCurve !== undefined) {
      BondingCurve.encode(message.bondingCurve, writer.uint32(34).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(42).fork()).ldelim();
    }
    if (message.iroPlanDuration !== undefined) {
      Duration.encode(message.iroPlanDuration, writer.uint32(50).fork()).ldelim();
    }
    if (message.incentivePlanParams !== undefined) {
      IncentivePlanParams.encode(message.incentivePlanParams, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgCreatePlan {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreatePlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string();
          break;
        case 2:
          message.rollappId = reader.string();
          break;
        case 3:
          message.allocatedAmount = reader.string();
          break;
        case 4:
          message.bondingCurve = BondingCurve.decode(reader, reader.uint32());
          break;
        case 5:
          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          break;
        case 6:
          message.iroPlanDuration = Duration.decode(reader, reader.uint32());
          break;
        case 7:
          message.incentivePlanParams = IncentivePlanParams.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgCreatePlan {
    return {
      owner: isSet(object.owner) ? String(object.owner) : "",
      rollappId: isSet(object.rollappId) ? String(object.rollappId) : "",
      allocatedAmount: isSet(object.allocatedAmount) ? String(object.allocatedAmount) : "",
      bondingCurve: isSet(object.bondingCurve) ? BondingCurve.fromJSON(object.bondingCurve) : undefined,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      iroPlanDuration: isSet(object.iroPlanDuration) ? Duration.fromJSON(object.iroPlanDuration) : undefined,
      incentivePlanParams: isSet(object.incentivePlanParams)
        ? IncentivePlanParams.fromJSON(object.incentivePlanParams)
        : undefined,
    };
  },

  toJSON(message: MsgCreatePlan): unknown {
    const obj: any = {};
    message.owner !== undefined && (obj.owner = message.owner);
    message.rollappId !== undefined && (obj.rollappId = message.rollappId);
    message.allocatedAmount !== undefined && (obj.allocatedAmount = message.allocatedAmount);
    message.bondingCurve !== undefined
      && (obj.bondingCurve = message.bondingCurve ? BondingCurve.toJSON(message.bondingCurve) : undefined);
    message.startTime !== undefined && (obj.startTime = message.startTime.toISOString());
    message.iroPlanDuration !== undefined
      && (obj.iroPlanDuration = message.iroPlanDuration ? Duration.toJSON(message.iroPlanDuration) : undefined);
    message.incentivePlanParams !== undefined && (obj.incentivePlanParams = message.incentivePlanParams
      ? IncentivePlanParams.toJSON(message.incentivePlanParams)
      : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgCreatePlan>, I>>(object: I): MsgCreatePlan {
    const message = createBaseMsgCreatePlan();
    message.owner = object.owner ?? "";
    message.rollappId = object.rollappId ?? "";
    message.allocatedAmount = object.allocatedAmount ?? "";
    message.bondingCurve = (object.bondingCurve !== undefined && object.bondingCurve !== null)
      ? BondingCurve.fromPartial(object.bondingCurve)
      : undefined;
    message.startTime = object.startTime ?? undefined;
    message.iroPlanDuration = (object.iroPlanDuration !== undefined && object.iroPlanDuration !== null)
      ? Duration.fromPartial(object.iroPlanDuration as Duration)
      : undefined;
    message.incentivePlanParams = (object.incentivePlanParams !== undefined && object.incentivePlanParams !== null)
      ? IncentivePlanParams.fromPartial(object.incentivePlanParams)
      : undefined;
    return message;
  },
};

function createBaseMsgCreatePlanResponse(): MsgCreatePlanResponse {
  return { planId: "" };
}

export const MsgCreatePlanResponse = {
  encode(message: MsgCreatePlanResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.planId !== "") {
      writer.uint32(10).string(message.planId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgCreatePlanResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreatePlanResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.planId = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgCreatePlanResponse {
    return { planId: isSet(object.planId) ? String(object.planId) : "" };
  },

  toJSON(message: MsgCreatePlanResponse): unknown {
    const obj: any = {};
    message.planId !== undefined && (obj.planId = message.planId);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgCreatePlanResponse>, I>>(object: I): MsgCreatePlanResponse {
    const message = createBaseMsgCreatePlanResponse();
    message.planId = object.planId ?? "";
    return message;
  },
};

function createBaseMsgBuy(): MsgBuy {
  return { buyer: "", planId: "", amount: "", maxCostAmount: "" };
}

export const MsgBuy = {
  encode(message: MsgBuy, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.buyer !== "") {
      writer.uint32(10).string(message.buyer);
    }
    if (message.planId !== "") {
      writer.uint32(18).string(message.planId);
    }
    if (message.amount !== "") {
      writer.uint32(26).string(message.amount);
    }
    if (message.maxCostAmount !== "") {
      writer.uint32(34).string(message.maxCostAmount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgBuy {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBuy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.buyer = reader.string();
          break;
        case 2:
          message.planId = reader.string();
          break;
        case 3:
          message.amount = reader.string();
          break;
        case 4:
          message.maxCostAmount = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgBuy {
    return {
      buyer: isSet(object.buyer) ? String(object.buyer) : "",
      planId: isSet(object.planId) ? String(object.planId) : "",
      amount: isSet(object.amount) ? String(object.amount) : "",
      maxCostAmount: isSet(object.maxCostAmount) ? String(object.maxCostAmount) : "",
    };
  },

  toJSON(message: MsgBuy): unknown {
    const obj: any = {};
    message.buyer !== undefined && (obj.buyer = message.buyer);
    message.planId !== undefined && (obj.planId = message.planId);
    message.amount !== undefined && (obj.amount = message.amount);
    message.maxCostAmount !== undefined && (obj.maxCostAmount = message.maxCostAmount);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgBuy>, I>>(object: I): MsgBuy {
    const message = createBaseMsgBuy();
    message.buyer = object.buyer ?? "";
    message.planId = object.planId ?? "";
    message.amount = object.amount ?? "";
    message.maxCostAmount = object.maxCostAmount ?? "";
    return message;
  },
};

function createBaseMsgBuyExactSpend(): MsgBuyExactSpend {
  return { buyer: "", planId: "", spend: "", minOutTokensAmount: "" };
}

export const MsgBuyExactSpend = {
  encode(message: MsgBuyExactSpend, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.buyer !== "") {
      writer.uint32(10).string(message.buyer);
    }
    if (message.planId !== "") {
      writer.uint32(18).string(message.planId);
    }
    if (message.spend !== "") {
      writer.uint32(26).string(message.spend);
    }
    if (message.minOutTokensAmount !== "") {
      writer.uint32(34).string(message.minOutTokensAmount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgBuyExactSpend {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBuyExactSpend();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.buyer = reader.string();
          break;
        case 2:
          message.planId = reader.string();
          break;
        case 3:
          message.spend = reader.string();
          break;
        case 4:
          message.minOutTokensAmount = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgBuyExactSpend {
    return {
      buyer: isSet(object.buyer) ? String(object.buyer) : "",
      planId: isSet(object.planId) ? String(object.planId) : "",
      spend: isSet(object.spend) ? String(object.spend) : "",
      minOutTokensAmount: isSet(object.minOutTokensAmount) ? String(object.minOutTokensAmount) : "",
    };
  },

  toJSON(message: MsgBuyExactSpend): unknown {
    const obj: any = {};
    message.buyer !== undefined && (obj.buyer = message.buyer);
    message.planId !== undefined && (obj.planId = message.planId);
    message.spend !== undefined && (obj.spend = message.spend);
    message.minOutTokensAmount !== undefined && (obj.minOutTokensAmount = message.minOutTokensAmount);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgBuyExactSpend>, I>>(object: I): MsgBuyExactSpend {
    const message = createBaseMsgBuyExactSpend();
    message.buyer = object.buyer ?? "";
    message.planId = object.planId ?? "";
    message.spend = object.spend ?? "";
    message.minOutTokensAmount = object.minOutTokensAmount ?? "";
    return message;
  },
};

function createBaseMsgBuyResponse(): MsgBuyResponse {
  return {};
}

export const MsgBuyResponse = {
  encode(_: MsgBuyResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgBuyResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgBuyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): MsgBuyResponse {
    return {};
  },

  toJSON(_: MsgBuyResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgBuyResponse>, I>>(_: I): MsgBuyResponse {
    const message = createBaseMsgBuyResponse();
    return message;
  },
};

function createBaseMsgSell(): MsgSell {
  return { seller: "", planId: "", amount: "", minIncomeAmount: "" };
}

export const MsgSell = {
  encode(message: MsgSell, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.seller !== "") {
      writer.uint32(10).string(message.seller);
    }
    if (message.planId !== "") {
      writer.uint32(18).string(message.planId);
    }
    if (message.amount !== "") {
      writer.uint32(26).string(message.amount);
    }
    if (message.minIncomeAmount !== "") {
      writer.uint32(34).string(message.minIncomeAmount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgSell {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSell();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.seller = reader.string();
          break;
        case 2:
          message.planId = reader.string();
          break;
        case 3:
          message.amount = reader.string();
          break;
        case 4:
          message.minIncomeAmount = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgSell {
    return {
      seller: isSet(object.seller) ? String(object.seller) : "",
      planId: isSet(object.planId) ? String(object.planId) : "",
      amount: isSet(object.amount) ? String(object.amount) : "",
      minIncomeAmount: isSet(object.minIncomeAmount) ? String(object.minIncomeAmount) : "",
    };
  },

  toJSON(message: MsgSell): unknown {
    const obj: any = {};
    message.seller !== undefined && (obj.seller = message.seller);
    message.planId !== undefined && (obj.planId = message.planId);
    message.amount !== undefined && (obj.amount = message.amount);
    message.minIncomeAmount !== undefined && (obj.minIncomeAmount = message.minIncomeAmount);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgSell>, I>>(object: I): MsgSell {
    const message = createBaseMsgSell();
    message.seller = object.seller ?? "";
    message.planId = object.planId ?? "";
    message.amount = object.amount ?? "";
    message.minIncomeAmount = object.minIncomeAmount ?? "";
    return message;
  },
};

function createBaseMsgSellResponse(): MsgSellResponse {
  return {};
}

export const MsgSellResponse = {
  encode(_: MsgSellResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgSellResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSellResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): MsgSellResponse {
    return {};
  },

  toJSON(_: MsgSellResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgSellResponse>, I>>(_: I): MsgSellResponse {
    const message = createBaseMsgSellResponse();
    return message;
  },
};

function createBaseMsgClaim(): MsgClaim {
  return { claimer: "", planId: "" };
}

export const MsgClaim = {
  encode(message: MsgClaim, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.claimer !== "") {
      writer.uint32(10).string(message.claimer);
    }
    if (message.planId !== "") {
      writer.uint32(18).string(message.planId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgClaim {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgClaim();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.claimer = reader.string();
          break;
        case 2:
          message.planId = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgClaim {
    return {
      claimer: isSet(object.claimer) ? String(object.claimer) : "",
      planId: isSet(object.planId) ? String(object.planId) : "",
    };
  },

  toJSON(message: MsgClaim): unknown {
    const obj: any = {};
    message.claimer !== undefined && (obj.claimer = message.claimer);
    message.planId !== undefined && (obj.planId = message.planId);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgClaim>, I>>(object: I): MsgClaim {
    const message = createBaseMsgClaim();
    message.claimer = object.claimer ?? "";
    message.planId = object.planId ?? "";
    return message;
  },
};

function createBaseMsgClaimResponse(): MsgClaimResponse {
  return {};
}

export const MsgClaimResponse = {
  encode(_: MsgClaimResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgClaimResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgClaimResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): MsgClaimResponse {
    return {};
  },

  toJSON(_: MsgClaimResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgClaimResponse>, I>>(_: I): MsgClaimResponse {
    const message = createBaseMsgClaimResponse();
    return message;
  },
};

/** Msg defines the Msg service. */
export interface Msg {
  /** UpdateParams is used for updating module params. */
  UpdateParams(request: MsgUpdateParams): Promise<MsgUpdateParamsResponse>;
  /** CreatePlan is used to create a new plan. */
  CreatePlan(request: MsgCreatePlan): Promise<MsgCreatePlanResponse>;
  /** Buy is used to buy allocation. */
  Buy(request: MsgBuy): Promise<MsgBuyResponse>;
  BuyExactSpend(request: MsgBuyExactSpend): Promise<MsgBuyResponse>;
  /** Sell is used to sell allocation. */
  Sell(request: MsgSell): Promise<MsgSellResponse>;
  /** Claim is used to claim tokens after the plan is settled. */
  Claim(request: MsgClaim): Promise<MsgClaimResponse>;
}

export class MsgClientImpl implements Msg {
  private readonly rpc: Rpc;
  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.UpdateParams = this.UpdateParams.bind(this);
    this.CreatePlan = this.CreatePlan.bind(this);
    this.Buy = this.Buy.bind(this);
    this.BuyExactSpend = this.BuyExactSpend.bind(this);
    this.Sell = this.Sell.bind(this);
    this.Claim = this.Claim.bind(this);
  }
  UpdateParams(request: MsgUpdateParams): Promise<MsgUpdateParamsResponse> {
    const data = MsgUpdateParams.encode(request).finish();
    const promise = this.rpc.request("dymensionxyz.dymension.iro.Msg", "UpdateParams", data);
    return promise.then((data) => MsgUpdateParamsResponse.decode(new _m0.Reader(data)));
  }

  CreatePlan(request: MsgCreatePlan): Promise<MsgCreatePlanResponse> {
    const data = MsgCreatePlan.encode(request).finish();
    const promise = this.rpc.request("dymensionxyz.dymension.iro.Msg", "CreatePlan", data);
    return promise.then((data) => MsgCreatePlanResponse.decode(new _m0.Reader(data)));
  }

  Buy(request: MsgBuy): Promise<MsgBuyResponse> {
    const data = MsgBuy.encode(request).finish();
    const promise = this.rpc.request("dymensionxyz.dymension.iro.Msg", "Buy", data);
    return promise.then((data) => MsgBuyResponse.decode(new _m0.Reader(data)));
  }

  BuyExactSpend(request: MsgBuyExactSpend): Promise<MsgBuyResponse> {
    const data = MsgBuyExactSpend.encode(request).finish();
    const promise = this.rpc.request("dymensionxyz.dymension.iro.Msg", "BuyExactSpend", data);
    return promise.then((data) => MsgBuyResponse.decode(new _m0.Reader(data)));
  }

  Sell(request: MsgSell): Promise<MsgSellResponse> {
    const data = MsgSell.encode(request).finish();
    const promise = this.rpc.request("dymensionxyz.dymension.iro.Msg", "Sell", data);
    return promise.then((data) => MsgSellResponse.decode(new _m0.Reader(data)));
  }

  Claim(request: MsgClaim): Promise<MsgClaimResponse> {
    const data = MsgClaim.encode(request).finish();
    const promise = this.rpc.request("dymensionxyz.dymension.iro.Msg", "Claim", data);
    return promise.then((data) => MsgClaimResponse.decode(new _m0.Reader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = date.getTime() / 1_000;
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds: Long.fromNumber(seconds), nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = Number(t.seconds) * 1_000;
  millis += t.nanos / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
